var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"txs_filter_help",attrs:{"id":"txs_filter_help","title":"JSONPath Help","header-class":"modal_header","size":"lg","ok-only":""}},[_c('FilterHelp',{on:{"set":_vm.set_filter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }